export class RaciTemplateOverviewModel {
  /**
 * The ID of the entity.
 */
  oid: number;

  /**
   * The name of the entity.
   */
  name: string;

  /**
   * The description of the entity.
   */
  description: string;

  /**
   * The status of the entity (optional).
   */
  status?: number;
}
